// extracted by mini-css-extract-plugin
export var checkbox = "_2a-0";
export var circle = "_2a-3";
export var horizontalContainer = "_2a-7";
export var sm = "_2a-5";
export var switch0 = "_2a-2";
export var switchDisabled = "_2a-8";
export var switchEnabled = "_2a-1";
export var textSwitchContainer = "_2a-9";
export var textSwitchOption = "_2a-a";
export var textSwitchOptionSelected = "_2a-b";
export var verticalContainer = "_2a-6";
export var xs = "_2a-4";